<div
    class="flex-center flex flex-col justify-center"
    *ngIf="showAztecCode || showQRCode"
    [ngClass]="{ 'rounded-lg bg-white px-1 pt-1': env.IS_NEW_AFC }"
    [class.gap-4]="!env.IS_NEW_AFC"
    [class.py-8]="!isPage && !env.IS_NEW_AFC">
    <div class="dark:rounded-md dark:bg-contrast-white dark:p-4" (click)="qrClick.emit()">
        <qrcode
            *ngIf="showQRCode && !showAztecCode"
            [qrdata]="ticket.cardId"
            [size]="200"
            [level]="'M'"
            [attr.aria-label]="'QR_CHIP' | translate"></qrcode>
        <div
            class="aztecCode aspect-square max-w-[60mm] landscape:mt-2"
            #aztecContainer
            [hidden]="!showAztecCode && !aztecSvgLoaded"></div>
        <ridango-ui-basic-loading-spinner *ngIf="showAztecCode && !aztecSvgLoaded"></ridango-ui-basic-loading-spinner>
    </div>
    <p class="dark:text-filter-yellow mb-0 text-xs font-medium text-grey-dark" *ngIf="env.ZOOMABLE_QR_CODE && !isPage">
        {{ 'TAP_TO_ZOOM' | translate }}
    </p>
</div>
